import { IShareKakaoParams, shareKakaoTalk } from '@utils/KakaoUtils';
import classnames from 'classnames/bind';
import styles from './kakaoShareButton.module.scss';

const cx = classnames.bind(styles);

interface IKakaoShareButtonProps {
  title: string;
  description: string;
  imageUrl: string;
  webUrl: string;
  mobileWebUrl: string;
}

const KakaoShareButton = (props: IKakaoShareButtonProps) => {
  const { title, description, imageUrl, webUrl, mobileWebUrl } = props;

  const params: IShareKakaoParams = {
    title,
    description,
    imageUrl,
    webUrl,
    mobileWebUrl,
  };

  return (
    <li>
      <a className={cx('kakaoBtn')} role="button" onClick={() => shareKakaoTalk(params)} />
    </li>
  );
};

export default KakaoShareButton;
